import "babel-polyfill";
import Vue from 'vue'
import i18n from './locales.js'
import router from './router.js'
import store from './store.js'
import Vuetify from 'vuetify'
import App from './App.vue'

Vue.use(Vuetify);

router.beforeEach(function (to, from, next) {
  window.scrollTo(0, 0);
  next();
});

new Vue({
  el: '#app',
  i18n,
  router,
  store,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js